import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/configuraciones-de-uso-de-folios/';

/**
 * GET Configuraciones de uso de folios
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getConfiguracionesDeUsosDeFolios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Configuracion de uso de folios
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConfiguracionDeUsosDeFolios = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Configuracion de uso de folios
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionDeUsosDeFolios = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion de uso de folios
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionDeUsosDeFolios = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion de uso de folios
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConfiguracionDeUsosDeFolios = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {Object} values
 * @returns {Promise<object|boolean>}
 */
export const promiseAllUsosDeFolio = async (values) => {
  try {
    const datos = [];
    const promises = values.map((uso) => API
      .post('configuracion/configuraciones-de-uso-de-folios/', uso));
    if (promises.length) {
      const responses = await Promise.all(promises);
      datos.push(responses.map((e) => e.data));
    }
    if (datos?.length) {
      onSuccess(null, 'Actualizado Correctamente');
    }
    return datos;
  } catch (err) {
    onError(err);
    return false;
  }
};
